if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      this.lastScrollY = window.scrollY;
      window.addEventListener('scroll', this.setHideOnScroll.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      // Die Kopfzeile faehrt mit einer Transition weg oder herein. Der letzte
      // scroll-Aufruf liest ihre Lage beim Start der Bewegung; hoert man dann
      // auf zu scrollen, bliebe --header-offset auf dem Zwischenwert stehen und
      // die Filterspalte (facets.css, --filter-oben) hinge in der Luft. Deshalb
      // nach dem Ende der Bewegung noch einmal messen.
      this.header_section.addEventListener('transitionend', this.setHeaderOffset.bind(this));
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setHideOnScroll() {
      // Verhalten der Kopfzeile:
      //   1. Oben auf der Seite scrollt sie mit, in beide Richtungen. Wer
      //      wieder hochscrollt, sieht sie ganz normal zurueckkommen.
      //   2. Ist sie einmal draussen, bleibt sie draussen.
      //   3. Erst ab 20 Prozent der Seite holt Hochscrollen sie wieder herein.
      //      Davor kann man ungestoert bis nach oben scrollen.
      //
      // Sie bleibt dabei durchgehend klebend. Ein Umschalten auf position
      // static hatte Nebenwirkungen: setHeaderOffset schreibt --header-offset
      // aus ihrer Lage, und die wandert im freien Fluss weit ins Negative;
      // davon haengen Mobilmenue, klebende Filter und Hoehenrechnungen ab.
      // Das Mitscrollen entsteht deshalb ueber die Verschiebung.
      if (!this.header_section) return;

      const y = window.scrollY;
      const delta = y - this.lastScrollY;

      // Bei offenem Mobilmenue bleibt der Header stehen
      const menue_offen = this.toggle && this.toggle.classList.contains('active');

      // Lage und Hoehe einmal am Seitenanfang messen. Weiter unten liefert die
      // klebende Kopfzeile nicht mehr ihre Ruhelage.
      if (this.headerOben == null || y <= 0) {
        // Ohne die eigene Verschiebung messen. getBoundingClientRect liefert
        // die verschobene Lage; stuende hier noch eine Verschiebung, wanderte
        // der Bezugspunkt bei jedem Messen ein Stueck weiter nach oben. Genau
        // daher kam der gruene Streifen zwischen Kopfzeile und Inhalt: die
        // Kopfzeile sass dann dauerhaft zu hoch und gab den Seitenrahmen frei.
        const alteVerschiebung = this.header_section.style.transform;
        if (alteVerschiebung) this.header_section.style.transform = '';
        this.headerOben = Math.round(this.header_section.getBoundingClientRect().top + y);
        this.headerHoehe = this.header_section.offsetHeight;
        if (alteVerschiebung) this.header_section.style.transform = alteVerschiebung;
      }

      // Strecke, um die sie schon aus dem Bild geschoben ist, hoechstens ihre
      // eigene Hoehe. Bis dahin verhaelt sie sich wie normaler Seiteninhalt.
      const strecke = Math.max(0, Math.min(y - this.headerOben, this.headerHoehe));
      const inDerZone = strecke < this.headerHoehe;
      const istWeg = this.header_section.classList.contains('header-scrolled-away');

      // Ab hier holt Hochscrollen sie wieder herein.
      const zwanzigProzent = document.documentElement.scrollHeight * 0.2;

      const ohneUebergang = () => {
        this.header_section.classList.add('header-ohne-uebergang');
        window.clearTimeout(this.uebergangTimer);
        // Timeout statt requestAnimationFrame: rAF wird in Fenstern im
        // Hintergrund gedrosselt, die Klasse bliebe sonst haengen.
        this.uebergangTimer = window.setTimeout(() => {
          this.header_section.classList.remove('header-ohne-uebergang');
        }, 60);
      };

      if (menue_offen) {
        this.header_section.style.transform = '';
        this.header_section.classList.remove('header-scrolled-away');
        this.gleitet = false;
      } else if (inDerZone && (delta >= 0 || istWeg || this.gleitet || y <= 0)) {
        // Mitscrollen, in beide Richtungen, bis sie wieder ganz an ihrem Platz
        // ist. Das Merkmal gleitet haelt den Zustand ueber die Bildlaeufe
        // hinweg fest; ohne es sprang sie beim Hochscrollen nach dem ersten
        // Schritt von halb draussen auf ganz sichtbar.
        ohneUebergang();
        this.header_section.classList.remove('header-scrolled-away');
        this.header_section.style.transform = strecke > 0 ? 'translateY(-' + strecke + 'px)' : '';
        this.gleitet = strecke > 0;
      } else if (inDerZone) {
        this.header_section.style.transform = '';
        this.header_section.classList.remove('header-scrolled-away');
      } else {
        // Ausserhalb der Zone entscheidet die Klasse. Die Verschiebung von
        // Hand endet hier; am Uebergang sind beide Werte gleich, es springt
        // nichts.
        this.header_section.style.transform = '';
        if (delta > 0) {
          // Auch bei winzigen Schritten verschwinden, sonst bliebe sie am
          // oberen Rand kleben und fuehre erst spaeter heraus.
          this.header_section.classList.add('header-scrolled-away');
        } else if (delta < -4 && y >= zwanzigProzent) {
          this.header_section.classList.remove('header-scrolled-away');
          // Sie ist jetzt regulaer eingefadet. Beim spaeteren Hochscrollen in
          // den oberen Bereich soll sie nicht wieder ins Gleiten fallen.
          this.gleitet = false;
        }
      }

      // Derselbe Zustand am body. Elemente ausserhalb der Kopfzeile, etwa die
      // mitlaufende Leiste im Ratgeber, koennen sich so ohne :has darauf
      // beziehen.
      document.body.classList.toggle(
        'header-weggescrollt',
        this.header_section.classList.contains('header-scrolled-away')
      );

      this.lastScrollY = y;
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}